const getNestedKey = (object: any, key: string): string => {
  const [firstKey, ...rest] = key.split('.');

  if (rest.length === 0) return object[firstKey];
  return getNestedKey(object[firstKey], rest.join('.'));
};

export default getNestedKey;
